import DateTimeFiltersViewModel from "../../DateTimeFilters/ViewModels/DateTimeFiltersViewModel";

export default class QAComplaintsFiltersViewModel {
    isActive: boolean = false;
    qaComplaintType: string = '';
    qaComplaint: string[] = [];
    //pending logged ect.
    outcome: string[] = [];
    originator: string[] = [];

    searchLoggedDate: boolean = false;
    loggedDateFilter: DateTimeFiltersViewModel = new DateTimeFiltersViewModel();
}